import { createFileRoute } from '@tanstack/react-router';
import { PurchasingPage } from '@/features/purchasing/PurchasingWorkspace';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/')({ component: Page });
function Page() {
  const { jobId, orderId, supplierId, status, queue, create, via } = Route.useSearch();
  return (
    <PurchasingPage
      jobId={jobId}
      orderId={orderId}
      supplierId={supplierId}
      status={status}
      queue={queue}
      create={create}
      via={via}
    />
  );
}
